import { Dispatch } from "../../controller";
import { Contas, MeioPag, ResumoContasPessoa } from "../../data.types";
import { Model,StateProps } from "../../model";
import { Funcionario } from "../funcionario/funcionario.model";

export type { Contas } from "../../data.types";

export interface ContasGroup {
    tipo: "Pagar" | "Receber" | "";
    contas: Contas[];
}

export interface ResumoMeioPagRecebido {
    _id:any;
    descricao:string;
    valor:number
}

export interface ContasState extends StateProps<Contas> {
    contasGroup:ContasGroup[];
    contaGroup:ContasGroup;
    resumoMeiopagRecebidos: ResumoMeioPagRecebido[]
    contas_resumo: ResumoContasPessoa[],
    contaResumoSelected: ResumoContasPessoa,
    showLayouteFilter:boolean
    meioPagSelectedConta?:MeioPagSelectedConta    
    tabValue:number 
}

export interface NovaConta {
    tipo: "receber" | "pagar",
    pessoa: {
        _id: string,
        nome: string
    },
    movimentacao: {
        _id: string,
        codigo: string
    },
    descricao: string,
    valor: number,
    data_venc: string
}

export interface MeioPagSelectedConta  {
    meio: MeioPag,
    valor: number
}

export interface ReceberPagamento {
    pessoaId:string
    valor: number
    canalDist:{
        _id:string,
        funcionario: Funcionario,
        data: string,
    },
    meioPag:MeioPag
    contasDetalhes:Contas[]
}

interface NovaContaProps {
    tipo: "receber" | "pagar",
    pessoa: {
        _id: string,
        nome: string
    },

}
export interface ContasActions extends Dispatch<Contas> {
    readResumoContas:(tipo:"receber" | "pagar") => any
    setContasGroup:(rows:Contas[])=>any;    
    setContaGroup:(contaGroup:ContasGroup)=>any;
    handleNovaConta:(prm:NovaConta)=>any;
    readResumoMpRecebimentosByCanal:(canalId:string) => any
    receberPagamento: (value: ReceberPagamento) => any
    setContaResumoSelected:(contaResumo:ResumoContasPessoa)=>any
    setMeioPagSelectedConta:(meioPagSelected:MeioPagSelectedConta)=>any
    readContasDetalheByPessoa:(pessoaId:string)=>any
    setTabValue:(value:number)=>any
    
}

const model = new Model<Contas,ContasState>("contas");

const intialValueContasPag:Contas = {
    ...model.getInitialValue(),
    type:"contas",
    descricao:"",
    valor:0,
    pessoa:{_id:"",nome:""},
    movimentacao:{_id:"",codigo:""},
    data_venc:"",
    situacao:"aberto",
    tipo:"receber",
    recebimentos:[],
}

export const initialValueContasState:ContasState = {
    ...model.getInititalValueState(),
    row:intialValueContasPag,
    contasGroup:[],
    contaGroup:{tipo:"",contas:[]},
    contas_resumo: [],
    contaResumoSelected:{key:{_id:"",nome:""},value:0},
    showLayouteFilter:false,
    meioPagSelectedConta:undefined,
    resumoMeiopagRecebidos: [],
    tabValue:0,
}


